import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal__required-text" }
const _hoisted_2 = { class: "modal__selection modal__selection_table" }
const _hoisted_3 = { class: "modal__sub-title" }
const _hoisted_4 = { class: "modal__selection" }
const _hoisted_5 = { class: "modal__sub-title" }
const _hoisted_6 = { class: "modal__selection" }

import { useUnmanagedBusinessStore } from '@/unmanagedBusinessModule/pages/unmanagedBusinessStore';
import { storeToRefs } from 'pinia';
import { i18n } from '@/i18n';
import TextInput from './TextInput.vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import SimpleSelectInput from '@/corePagesModule/components/SelectInput.vue';
import Button from '@/components/input/Btn/Btn.vue';
import { computed, watch } from 'vue';
import { useForms } from '@/corePagesModule/composables/useForm';
import { validateRuleKeyMap, selectOptionKeyMap } from '../constants/formKeyMap';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import { UnmanagedBusinessService } from '../domains/services/UnmanagedBusinessService';
import { FieldItem, ValidateRule } from '@/coreDomainsModule/constant/validateRules';


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterUpdateInfoModal',
  setup(__props) {

const t = i18n.t;

const store = useUnmanagedBusinessStore();
const { state } = storeToRefs(store);
const { openModalByPreviousModal, openModal } = store;

const filedItems = computed((): FieldItem[] => {
  // 選択肢の項目を取得
  const items: FieldItem[] = [];
  Object.keys(state.value.modalInfo.modalState.checkDuplication.diffInfo).forEach((item) => {
    items.push({
      name: item,
      rules: validateRuleKeyMap[item],
    });
  });
  return items;
});

const { fieldState, allValidate, resetForm } = useForms(filedItems.value);

/**
 * 次へボタンクリック時の処理
 */
const onNext = () => {
  if (allValidate()) {
    state.value.settingUnmanagedBusiness.leadTime = Number(fieldState['leadTime'].value.value);
    state.value.settingUnmanagedBusiness.leadTimeUnit = UnmanagedBusinessService.convertUnitToSystemUnit(
      fieldState['leadTimeUnit'].value.value
    );
    state.value.settingUnmanagedBusiness.moq = Number(fieldState['MOQ'].value.value);
    state.value.settingUnmanagedBusiness.unit = fieldState['unit'].value.value;
    state.value.settingUnmanagedBusiness.stdInventoryIndices = {
      標準在庫指数: {
        min: Number(fieldState['stdInventoryIndicesMin'].value.value),
        max: Number(fieldState['stdInventoryIndicesMax'].value.value),
        option: {
          unit: UnmanagedBusinessService.convertUnitToSystemUnit(fieldState['stdInventoryIndicesUnit'].value.value),
        },
      },
    };
    openModalByPreviousModal('questionUpdateExistBusinessDiff');
  }
};

/**
 * 更新せず次へボタンクリック時の処理
 */
const onNextWhenNoUpdate = () => {
  state.value.settingUnmanagedBusiness.leadTime = state.value.modalInfo.modalState.checkDuplication.diffInfo.leadTime;
  state.value.settingUnmanagedBusiness.leadTimeUnit = state.value.modalInfo.modalState.checkDuplication.diffInfo.leadTimeUnit;
  state.value.settingUnmanagedBusiness.moq = state.value.modalInfo.modalState.checkDuplication.diffInfo.moq;
  state.value.settingUnmanagedBusiness.unit = state.value.modalInfo.modalState.checkDuplication.diffInfo.unit;
  state.value.settingUnmanagedBusiness.stdInventoryIndices = {
    標準在庫指数: {
      min: state.value.modalInfo.modalState.checkDuplication.diffInfo.stdInventoryIndicesMin,
      max: state.value.modalInfo.modalState.checkDuplication.diffInfo.stdInventoryIndicesMax,
      option: {
        unit: state.value.modalInfo.modalState.checkDuplication.diffInfo.stdInventoryIndicesUnit,
      },
    },
  };
  openModalByPreviousModal('questionUpdateExistBusinessDiff');
};

watch(
  () => state.value.modalInfo.isOpen.questionUpdateExistBusinessDiff,
  (value) => {
    if (value) {
      resetForm(filedItems.value);
      // settingUnmanagedBusinessの値をfieldStateにセット
      for (let i = 0; i < filedItems.value.length; i++) {
        const name = filedItems.value[i].name;
        fieldState[name].setValue(state.value.modalInfo.modalState.registerLeadTimeAndEtc[name], false);
      }
    }
  }
);

/**
 * バリデーションにRequiredがある場合は*を返す
 * @param key　- 入力項目のキー
 */
const getRequiredMark = (key: string | number) => {
  if (validateRuleKeyMap[key].includes(ValidateRule.Required)) {
    return '*';
  }
  return '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _unref(state).modalInfo.isOpen.questionUpdateExistBusinessDiff,
    "back-button-label": _unref(t)('戻る'),
    "next-button-label": _unref(t)('更新する'),
    onOnBack: _cache[7] || (_cache[7] = ($event: any) => (_unref(openModal)('detectDuplication'))),
    onOnNext: onNext
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('リードタイム、標準在庫指数、単位を更新しますか？')), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('すでに登録されていたをリードタイム、標準在庫指数、単位を更新することができます。')), 1)
    ]),
    betweenButtons: _withCtx(() => [
      _createVNode(Button, {
        class: _normalizeClass(`modal__button modal__button--save`),
        onClick: onNextWhenNoUpdate
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('更新せず次へ')), 1)
        ], undefined, true),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)('*マークは必須')), 1),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(NewBaseTableContent, {
            "prop-table-id": 'RegisterUpdateInfoModal',
            "prop-table-content-properties": _unref(state).tableInfo.modal.tableContentProperties,
            "prop-display-objects": _unref(state).tableInfo.modal.tableContentItems,
            "prop-loading-status": _unref(state).tableInfo.modal.loadingState,
            "prop-table-type": 'unmanagedBusinessTypeModal',
            class: "modal__table"
          }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status"])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('既存登録情報')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TextInput, {
            "model-value": _unref(state).modalInfo.modalState.checkDuplication.diffInfo.leadTime.toString(),
            label: _unref(t)('取引登録モーダル選択肢:leadTime') + getRequiredMark('leadTime'),
            placeholder: "",
            disabled: true
          }, null, 8, ["model-value", "label"]),
          _createVNode(TextInput, {
            "model-value": 
            _unref(UnmanagedBusinessService).convertSystemUnitToDisplayUnit(
              _unref(state).modalInfo.modalState.checkDuplication.diffInfo.leadTimeUnit.toString()
            )
          ,
            label: _unref(t)('取引登録モーダル選択肢:leadTimeUnit') + getRequiredMark('leadTimeUnit'),
            placeholder: "",
            disabled: true
          }, null, 8, ["model-value", "label"]),
          _createVNode(TextInput, {
            "model-value": _unref(state).modalInfo.modalState.checkDuplication.diffInfo.moq.toString(),
            label: _unref(t)('取引登録モーダル選択肢:MOQ') + getRequiredMark('MOQ'),
            placeholder: "",
            disabled: true
          }, null, 8, ["model-value", "label"]),
          _createVNode(TextInput, {
            "model-value": _unref(state).modalInfo.modalState.checkDuplication.diffInfo.unit?.toString() || '',
            label: _unref(t)('取引登録モーダル選択肢:unit') + getRequiredMark('unit'),
            placeholder: "",
            disabled: true
          }, null, 8, ["model-value", "label"]),
          _createVNode(TextInput, {
            "model-value": _unref(state).modalInfo.modalState.checkDuplication.diffInfo.stdInventoryIndicesMin.toString(),
            label: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesMin') + getRequiredMark('stdInventoryIndicesMin'),
            placeholder: "",
            disabled: true
          }, null, 8, ["model-value", "label"]),
          _createVNode(TextInput, {
            "model-value": _unref(state).modalInfo.modalState.checkDuplication.diffInfo.stdInventoryIndicesMax.toString(),
            label: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesMax') + getRequiredMark('stdInventoryIndicesMax'),
            placeholder: "",
            disabled: true
          }, null, 8, ["model-value", "label"]),
          _createVNode(TextInput, {
            "model-value": 
            _unref(UnmanagedBusinessService).convertSystemUnitToDisplayUnit(
              _unref(state).modalInfo.modalState.checkDuplication.diffInfo.stdInventoryIndicesUnit.toString()
            )
          ,
            label: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesUnit') + getRequiredMark('stdInventoryIndicesUnit'),
            placeholder: "",
            disabled: true
          }, null, 8, ["model-value", "label"])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('更新情報')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(TextInput, {
            "model-value": _unref(fieldState).leadTime.value.value,
            label: _unref(t)('取引登録モーダル選択肢:leadTime') + getRequiredMark('leadTime'),
            "is-error": _unref(fieldState).leadTime.isError.value,
            "error-message": _unref(fieldState).leadTime.errorMessage.value,
            placeholder: _unref(t)('取引登録モーダル選択肢:leadTime'),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = (e) => _unref(fieldState).leadTime.setValue(e))
          }, null, 8, ["model-value", "label", "is-error", "error-message", "placeholder"]),
          _createVNode(SimpleSelectInput, {
            "model-value": _unref(fieldState).leadTimeUnit.value.value,
            index: 4,
            label: _unref(t)('取引登録モーダル選択肢:leadTimeUnit') + getRequiredMark('leadTimeUnit'),
            "is-error": _unref(fieldState).leadTimeUnit.isError.value,
            "error-message": _unref(fieldState).leadTimeUnit.errorMessage.value,
            placeholder: _unref(t)('取引登録モーダル選択肢:leadTimeUnit'),
            options: _unref(selectOptionKeyMap).leadTimeUnit.map((item) => _unref(t)(item)),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = (e) => _unref(fieldState).leadTimeUnit.setValue(e))
          }, null, 8, ["model-value", "label", "is-error", "error-message", "placeholder", "options"]),
          _createVNode(TextInput, {
            "model-value": _unref(fieldState).moq.value.value,
            label: _unref(t)('取引登録モーダル選択肢:MOQ') + getRequiredMark('MOQ'),
            "is-error": _unref(fieldState).moq.isError.value,
            "error-message": _unref(fieldState).moq.errorMessage.value,
            placeholder: _unref(t)('取引登録モーダル選択肢:MOQ'),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = (e) => _unref(fieldState).moq.setValue(e))
          }, null, 8, ["model-value", "label", "is-error", "error-message", "placeholder"]),
          _createVNode(TextInput, {
            "model-value": _unref(fieldState).unit.value.value,
            label: _unref(t)('取引登録モーダル選択肢:unit') + getRequiredMark('unit'),
            "is-error": _unref(fieldState).unit.isError.value,
            "error-message": _unref(fieldState).unit.errorMessage.value,
            placeholder: _unref(t)('取引登録モーダル選択肢:unit'),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = (e) => _unref(fieldState).unit.setValue(e))
          }, null, 8, ["model-value", "label", "is-error", "error-message", "placeholder"]),
          _createVNode(TextInput, {
            "model-value": _unref(fieldState).stdInventoryIndicesMin.value.value,
            label: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesMin') + getRequiredMark('stdInventoryIndicesMin'),
            "is-error": _unref(fieldState).stdInventoryIndicesMin.isError.value,
            "error-message": _unref(fieldState).stdInventoryIndicesMin.errorMessage.value,
            placeholder: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesMin'),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = (e) => _unref(fieldState).stdInventoryIndicesMin.setValue(e))
          }, null, 8, ["model-value", "label", "is-error", "error-message", "placeholder"]),
          _createVNode(TextInput, {
            "model-value": _unref(fieldState).stdInventoryIndicesMax.value.value,
            label: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesMax') + getRequiredMark('stdInventoryIndicesMax'),
            "is-error": _unref(fieldState).stdInventoryIndicesMax.isError.value,
            "error-message": _unref(fieldState).stdInventoryIndicesMax.errorMessage.value,
            placeholder: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesMax'),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = (e) => _unref(fieldState).stdInventoryIndicesMax.setValue(e))
          }, null, 8, ["model-value", "label", "is-error", "error-message", "placeholder"]),
          _createVNode(SimpleSelectInput, {
            "model-value": _unref(fieldState).stdInventoryIndicesUnit.value.value,
            index: 6,
            label: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesUnit') + getRequiredMark('stdInventoryIndicesUnit'),
            "is-error": _unref(fieldState).stdInventoryIndicesUnit.isError.value,
            "error-message": _unref(fieldState).stdInventoryIndicesUnit.errorMessage.value,
            placeholder: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesUnit'),
            options: _unref(selectOptionKeyMap).stdInventoryIndicesUnit.map((item) => _unref(t)(item)),
            "onUpdate:modelValue": _cache[6] || (_cache[6] = (e) => _unref(fieldState).stdInventoryIndicesUnit.setValue(e))
          }, null, 8, ["model-value", "label", "is-error", "error-message", "placeholder", "options"])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label"]))
}
}

})